import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
// import { routes } from './routes';
import './App.css';
import { useEffect, useState } from 'react';
import { EntityProvider } from './contexts/EntityContext';
import Dashboard from './pages/Dashboard/dashboard';
import Comunicaciones from './pages/Comunicaciones/comunicaciones';
import Documentacion from './pages/Documentacion/documentacion';
import { TramitsIniciarNou } from './pages/Tramits/TramitsIniciarNou';
import { TramitsConsultar } from './pages/Tramits/TramitsConsultar';
import { TramitsDetall } from './pages/Tramits/TramitsDetall';
import { TramesesIniciarNova } from './pages/Trameses/TramesesIniciarNova';
import { TramesesConsultar } from './pages/Trameses/TramesesConsultar';
import { TramesesDetall } from './pages/Trameses/TramesesDetall';
import { TramesesQuadreControl } from './pages/Trameses/TramesesQuadreControl';

import { theme } from './theme';
import IAppProps from './IAppProps';
import NotSignedIn from './pages/NotSignedIn/NotSignedIn';
import { Layout } from './layouts/AppShell/Layout';
import ComunicacionesDetall from './pages/ComunicacionesDetall/comunicacionesdetall';
import { AfaPageLoader } from './components/ui';
import { CambiarEntitatModal } from './components/Modals/CambiarEntitatModal';
import ServiceUnavailable from './pages/ServiceUnavailable/ServiceUnavailable';

// Componente para hacer scroll hacia arriba en cada cambio de ruta
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App(props: IAppProps) {
  const [user, setUser] = useState(null as any);
  const [loading, setLoading] = useState(true);
  const [userError, setUserError] = useState<'service_unavailable' | 'not_authorized' | null>(null);
  const [entity, setEntity] = useState(null as any);
  const [cambiarEntitatModalOpened, setCambiarEntitatModalOpened] = useState(entity != null ? false : true);

  useEffect(() => {
    const initAuth = async () => {
      const account = await props.authServiceInstance.HandlePageLoadEvent();
      if (account) {
        
        // var userRes = await props.apiService.GetUser();
        // setUser(userRes);
        // setLoading(false);
        try {
          var userRes = await props.apiService.GetUser();
          setUser(userRes);
        } catch (err: any) {
          if (err.status === 500) {
            setUserError('not_authorized');
          } else {
            setUserError('service_unavailable');
          }
        } finally {
          setLoading(false);
        }

      } else {
        console.error("No hay usuario logueado");
        setLoading(false);
      }
    };

    initAuth();
  }, []);

  const invokeSignInEvent = () => {
    props.authServiceInstance.SignIn();
  }

  const invokeSignOutEvent = () => {
    props.authServiceInstance.SignOut();
  }

  return (
    <MantineProvider theme={theme} defaultColorScheme="light">
      <EntityProvider>
        <Notifications position="bottom-center" notificationMaxHeight={"1000px"} />
        {loading ?
          <AfaPageLoader message="Carregant..." />
          : userError ?
            <ServiceUnavailable errorType={userError} />
          :          
          (props.authServiceInstance.account) ?
            <BrowserRouter>
              <ScrollToTop />
              <Layout logOut={invokeSignOutEvent} user={user} entity={entity} setEntity={setEntity} setCambiarEntitatModalOpened={setCambiarEntitatModalOpened}>
                <div key={entity}>
                  {entity &&
                    <Routes>
                      <Route path="/" element={<Dashboard showAlerts={user.user.entitats.length > 1} apiService={props.apiService} entity={entity} user={user} />}></Route>
                      <Route path="/dashboard" element={<Dashboard showAlerts={user.user.entitats.length > 1} apiService={props.apiService} entity={entity} user={user} />}></Route>
                      <Route path="/comunicaciones" element={<Comunicaciones apiService={props.apiService} />}></Route>
                      <Route path="/comunicaciones/detall/:id" element={<ComunicacionesDetall apiService={props.apiService} />}></Route>
                      <Route path="/documentacion" element={<Documentacion  apiService={props.apiService} entity={entity} />}></Route>
                      {
                        user.user.tramits &&
                        <>
                          <Route path="/tramits/detall/:id" element={<TramitsDetall apiService={props.apiService} entity={entity} />}></Route>
                          <Route path="/tramits/iniciar-nou" element={<TramitsIniciarNou apiService={props.apiService} entity={entity} />}></Route>
                          <Route path="/tramits/editar/:id" element={<TramitsIniciarNou apiService={props.apiService} entity={entity} />}></Route>
                          <Route path="/tramits/consultar" element={<TramitsConsultar apiService={props.apiService} entity={entity} user={user} />}></Route>
                        </>
                      }
                      {
                        user.user.trameses &&
                        <>
                          <Route path="/trameses/consultar" element={<TramesesConsultar apiService={props.apiService} entity={entity} user={user} />}></Route>
                          <Route path="/trameses/iniciar-nova" element={<TramesesIniciarNova apiService={props.apiService} entity={entity} />}></Route>
                          <Route path="/trameses/editar/:id" element={<TramesesIniciarNova apiService={props.apiService} entity={entity} />}></Route>
                          <Route path="/trameses/detall/:id" element={<TramesesDetall apiService={props.apiService} entity={entity} user={user} />}></Route>
                          <Route path="/trameses/quadre-control" element={<TramesesQuadreControl user={user} apiService={props.apiService} entity={entity} />}></Route>
                        </>
                      }
                    </Routes>
                  }
                </div>
              </Layout>
              {/* Modal de Cambiar Entidad */}
              <CambiarEntitatModal
                opened={cambiarEntitatModalOpened}
                onClose={() => setCambiarEntitatModalOpened(false)}
                currentEntitat={entity}
                onSubmit={(entitatName: string) => {
                  setEntity(entitatName);
                  setCambiarEntitatModalOpened(false);
                  window.location.reload();
                }}
                ENTITATS_DATA={user.user.entitats} />
            </BrowserRouter>
            :
            <div className="App">
              <NotSignedIn
                authServiceInstance={props.authServiceInstance}
                loginButtonClicked={invokeSignInEvent}
              />
            </div>
        }
      </EntityProvider>
    </MantineProvider>
  );
}

export default App;
